import NiceModal from '@ebay/nice-modal-react';
import { Box, Modal } from '@mantine/core';
import { AnimatePresence, motion } from 'framer-motion';

import { useQrAuth } from '../../../../../hooks';

import { fade } from './constants';
import { FailureState, QrAuthBody } from './QrAuthBody';

type Props = {
  pageId: string;
  pageName: string;
};

export const QrAuthModal = NiceModal.create(({ pageId, pageName }: Props) => {
  const { qrAuth, failureMessage, isOpened, handleClose } = useQrAuth({ pageId });

  return (
    <Modal
      centered
      size={380}
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={isOpened}
      onClose={handleClose}
      title={`Connect ${pageName} via QR`}
    >
      <Box mih={340} pt="lg">
        <AnimatePresence exitBeforeEnter>
          {failureMessage ? (
            <motion.div key="failure" {...fade}>
              <FailureState message={failureMessage} onClose={handleClose} />
            </motion.div>
          ) : (
            <motion.div key={qrAuth?.status ?? 'starting'} {...fade}>
              <QrAuthBody qrAuth={qrAuth} pageId={pageId} />
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </Modal>
  );
});
